/**
 * Route handles (KPR-1579): what a route tells the layout above it, declared
 * on the route itself (`<Route handle={…}>`) and read by the layout with
 * `useMatches()` — never worked out by splitting the pathname.
 *
 * The collection shell. `pages/CollectionsLayout` draws the collection's
 * header (breadcrumb, badge, tabs, its actions) only on a child route marked
 * `SHELL_LAYOUT`: the collection's own surfaces and what sits inside them (an
 * item, the add form). Every other child has no handle and draws its own bar,
 * with the collection as a crumb — so a route added without one can never
 * stack two headers; at worst it draws its own. `SHELL_LAYOUT_SAVE` is the
 * same for the routes that hold the collection form (Settings, Cards), whose
 * one filled primary is Save changes, so the header's Add item steps aside.
 *
 * The portals. `adminSection(key)` and `docsSection(key)` name the nav entry a
 * child of `/admin` or `/docs` belongs to; `AdminLayout` and `DocsLayout`
 * mark it from the leaf route's handle.
 */
export const SHELL_LAYOUT = Object.freeze({ shell: 'layout' });
export const SHELL_LAYOUT_SAVE = Object.freeze({ shell: 'layout', primary: 'save' });

export const adminSection = key => Object.freeze({ adminSection: key });
export const docsSection = key => Object.freeze({ docsSection: key });

/** The handle of the deepest matched route (`useMatches()`'s last), or `{}`. */
export const leafHandle = matches => (Array.isArray(matches) && matches.length ? matches[matches.length - 1]?.handle : null) || {};
